import {Device} from '@gongxigames/framework/core';
import {ScrollToFullscreen} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/ScrollToFullscreen';
import {ScrollToFullscreenIOS161} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/ScrollToFullscreenIOS161';
import {ScrollForSpecificIOS15} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/ScrollForSpecificIOS15';
import {ScrollForOldVersionIOS} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/ScrollForOldVersionIOS';
import {IScrollToFullscreen} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/IScrollToFullscreen';

const ScrollToFullscreenImplementations = [
    ScrollForSpecificIOS15,
    ScrollToFullscreen,
    ScrollToFullscreenIOS161
];

export function createScrollToFullscreen(device: Device): IScrollToFullscreen {
    for (const ScrollToFullscreenConstructor of ScrollToFullscreenImplementations) {
        if (ScrollToFullscreenConstructor.matchVersion(device.iOSVersion)) {
            return new ScrollToFullscreenConstructor();
        }
    }

    return new ScrollForOldVersionIOS(device.mobileSafari);
}
